module.exports = __webpack_public_path__ + "media/images/pillar_google-45850483f7f47f23df39100bcebac23f.jpg";